const QA = [{
  q: '付款方式是怎么样的？',
  a: '微型项目（开发周期1个月以下）付全款，小型项目（3个月以下）分两期付款，每期50%，第一期为开发前，第二期为开发验收后。大型项目根据实际项目阶段划分。'
}, {
  q: '软件开发完成是否交付代码？',
  a: '当然，您拥有完整开发代码的所有权。'
}, {
  q: '软件后期维护还有什么费用？',
  a: '没有新增功能的情况下，不会有任何费用。'
}, {
  q: '你们的报价为什么比其他公司贵/便宜这么多？',
  a: '这是因为比较对象不同，但我们非常确信我们的报价是专业开发团队中最低的一档。'
}]

// 职工数据
const works = [
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/4282f6eb-6de0-4ce7-80c6-bdd220a7de21.png',
    name: '架构师',
    tooltip: '设计系统架构，定制技术方案，解决技术难题，检查代码质量',
    isClick: true
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/50cc5f3d-e08a-4c4e-95aa-438dc2335dda.png',
    name: '工程师',
    tooltip: '基于架构编写软件代码',
    isClick: false
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/151e17bd-79a6-4d05-98f6-71fc8e2200bd.png',
    name: '产品经理',
    tooltip: '设计产品原型，优化用户体验',
    isClick: false
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/d3e9a004-2fe7-415e-b3a8-d61a8d637a17.png',
    name: '设计师',
    tooltip: '根据产品原型设计页面',
    isClick: false
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/d4ef2ef6-f8dc-4eca-bcd5-30f9ea74423b.png',
    name: '测试<br>工程师',
    tooltip: '测试软件功能，提高软件质量',
    isClick: false
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/c5ecdaf3-21e3-412a-b8a4-a739c2c606b0.png',
    name: '运维<br>工程师',
    tooltip: '维护服务器，确保软件稳定运行',
    isClick: false
  }
]

// 成功案例
const cases = [
  // {
  //   QRcode: 'http://moke-store.oss-cn-beijing.aliyuncs.com/cba2dcfc-6826-431c-89c3-4ecfd6794c66.png',
  //   text: '超威云商城'
  // },
  // {
  //   QRcode: 'http://moke-store.oss-cn-beijing.aliyuncs.com/5162ce49-eb79-4904-98bc-0147d0b0d462.png',
  //   text: '乡镇一键通'
  // },
  // {
  //   QRcode: 'http://moke-store.oss-cn-beijing.aliyuncs.com/6eb4b61e-c855-4bd7-983c-eb2b2acd5ab7.png',
  //   text: '沃特德'
  // },
  // {
  //   QRcode: 'http://moke-store.oss-cn-beijing.aliyuncs.com/6eb4b61e-c855-4bd7-983c-eb2b2acd5ab7.png',
  //   text: '中心医院'
  // },
  // {
  //   QRcode: 'http://moke-store.oss-cn-beijing.aliyuncs.com/a86ea766-e3a8-4515-bb32-952c50b7e921.png',
  //   text: '101法律'
  // },
  // {
  //   QRcode: 'http://moke-store.oss-cn-beijing.aliyuncs.com/0724aa44-fa3e-490f-8b26-f9caf9953a8e.png',
  //   text: '杜桥派出所'
  // },
  // {
  //   QRcode: 'http://moke-store.oss-cn-beijing.aliyuncs.com/8106256b-a645-4536-9e87-200ed592d6e6.png',
  //   text: '农业嘉年华'
  // },
  // {
  //   QRcode: 'http://moke-store.oss-cn-beijing.aliyuncs.com/214e4bbf-2fca-41dc-9c41-70ea921473f3.png',
  //   text: '万行小程序'
  // }
]

// 阿里数据
const aliOss = [
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/9af204ed-5411-4c8e-8d26-b2532a38687f.png',
    title: '带宽无上限',
    tooltip: '存储软件用到的所有图片和文件，带宽无上限'
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/83c1d8e6-d754-4104-8630-cdc4e0f09761.png',
    title: '页面加载速度提升60%',
    tooltip: '全自动图片压缩处理，提升页面加载速度60%'
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/03fff02d-dad9-4c83-9ef8-e856f9c6457d.png',
    title: '自动无损压缩，体积减少99%',
    tooltip: '体积占用更少，画质完全一致'
  }
]

// 阿里数据库
const aliDatabase = [
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/5e3cac6f-d44f-4cc5-b6e3-35b26d6df89e.png',
    title: '数据全存储',
    tooltip: '存储软件中的所有数据（例如用户信息、订单数据等）'
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/864aa8d2-e881-40af-8f31-f7280bec2905.png',
    title: '数据99.99%可用性',
    tooltip: '固态硬盘，三节点部署，99.99%可用性'
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/93560594-80d9-431e-8724-ea2e0c5c5f42.png',
    title: '三节点部署',
    tooltip: '同时使用三台服务器，任意一台宕机，整体使用不受影响'
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/2f377228-c5bc-4849-a206-56c1bf93c46d.png',
    title: '数据全时备份',
    tooltip: '一个月内，全时备份，可还原数据到一个月内的任意时间，杜绝数据丢失'
  }
]

// 阿里
const aliContainer = [
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/d0eda9e2-4da9-48e1-9d41-7d16d593f62e.png',
    title: '服务器集群',
    tooltip: '用来部署软件核心业务程序，并非一台服务器，而是一个服务器集群'
  },
  {
    img: 'http://moke-store.oss-cn-beijing.aliyuncs.com/793c0a98-c2ff-4bdd-b964-a0486f970c56.png',
    title: '杜绝“越用越卡”',
    tooltip: '数据安全，分布式，容灾都只是最基本的需求，现代的容器集群可以全自动调整容器大小与数量，从容处理大数据业务，无限扩容，绝不会影响你的业务进展，杜绝“越用越卡'
  }
]

// 图片链接
const imageUrl = {
  serviceBtnPc: 'http://moke-store.oss-cn-beijing.aliyuncs.com/8655c668-bf00-404c-bd41-00b90eac6e8d.png',
  serviceBtnMobile: 'http://moke-store.oss-cn-beijing.aliyuncs.com/2a40d288-6137-4917-947e-7715325417ef.png',
  servicePromotePc: 'http://moke-store.oss-cn-beijing.aliyuncs.com/73c3bd4d-c2b1-4521-a7ab-6c045bd8d16a.png',
  servicePromoteMobile: 'http://moke-store.oss-cn-beijing.aliyuncs.com/956b9a71-4994-4da2-b09f-05cc23f74cc1.png',
  serverAPc: 'http://moke-store.oss-cn-beijing.aliyuncs.com/ce0da708-a0ad-49f2-a9e8-15179bb75b74.png',
  serverAMobile: 'http://moke-store.oss-cn-beijing.aliyuncs.com/f38aa93a-7888-4157-8578-e66330805cfe.png',
  serverBPc: 'http://moke-store.oss-cn-beijing.aliyuncs.com/0aedbc32-6dc7-4640-a350-f24f5ad5c2af.png',
  serverBMobile: 'http://moke-store.oss-cn-beijing.aliyuncs.com/fbc4db54-a26b-48db-bd2a-d1df2113ccde.png',
  serverCPc: 'http://moke-store.oss-cn-beijing.aliyuncs.com/8bc9a3d0-b908-4683-8228-55532037ff69.png',
  serverCMobile: 'http://moke-store.oss-cn-beijing.aliyuncs.com/1d9eb5f6-c8f6-4095-a1f9-a23710e8b1b6.png',
  serverDPc: 'http://moke-store.oss-cn-beijing.aliyuncs.com/269e9b17-a473-4b43-97f3-c275eeaac6f3.png',
  serverDMobile: 'http://moke-store.oss-cn-beijing.aliyuncs.com/f9abd14c-5b5a-423c-a3d4-44cf8838015a.png',
  serverEPc: 'http://moke-store.oss-cn-beijing.aliyuncs.com/54d5d56f-b6c7-4392-ae1f-77fbc63fb49c.png',
  serverEMobile: 'http://moke-store.oss-cn-beijing.aliyuncs.com/277aa953-455e-4882-ab57-9c91472e29d4.png'
}

// 常见问题
const commonProblem = [{
  q: '什么软件都可以免费用服务器吗？',
  a: `以下情况例外：1、智能硬件项目，2、月活跃用户量超过十万人，3、海外项目<br>以上情况的服务器成本甚至高过开发成本，我们无法免费提供，请自购服务器。`
}, {
  q: '两年到期了怎么办？',
  a: '两年之内，软件有任何付费更新时，免费时间自动顺延。通常来说，软件如果两年没做任何更新，大多已不再使用，自然也不需要服务器。'
}]

export { QA, works, cases, aliOss, aliDatabase, aliContainer, imageUrl, commonProblem }
